export const LEQ_updateLimitEnhanceDetailsReducer = {
  LEQ_updateLimitEnhanceDetails: (state, action) => {
    state.limitEnhanceDetails = { ...action.payload };
  },
};
